import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Radio,
  TablePagination,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import Loader from 'components/loader/Loader';
import { abbreviateNumber, formatCurrency } from 'utils/utils';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import { StyledTableCell } from 'components/commonTable/CommonTableStyle';

const PaymentTable = (props) => {
  const {
    invoiceTableData,
    handleRadioSelected,
    selectedRow,
    companyInvoiceLoading,
  } = props;

  const [expandedRow, setExpandedRow] = useState(null);

  const handleRowClick = (index, isExpandIconClick, body) => {
    if (isExpandIconClick) {
      setExpandedRow((prev) => (prev === index ? null : index));
    }
    if(props?.pageName !== 'paymentDetails'){
    handleRadioSelected(index,isExpandIconClick, body)}
  };

  const handleHeaderKey = (headerKey) => {
    const keysToAddSeparator = [
      'totalAmount',
      'amountSettled',
      'outstandingAmount',
      'grossAmt',
      'gstAmt',
      'tds',
    ];
  
    return keysToAddSeparator.includes(headerKey);
  };

  return (
    <Box className="commonBorder br10 pb40">
      <Box className="bgViolet">
        <Typography className="fw400 p20" variant="body3" component={'h6'}>
          Invoice
        </Typography>
      </Box>
      {companyInvoiceLoading ? (
        <Loader />
      ) : (
        <TableContainer>
          <Table aria-label="simple table" className="paymentInvoiceTable">
            <TableHead>
              <TableRow className="comColumnWidth">
                {props?.pageName !== 'paymentDetails' && (
                  <TableCell></TableCell>
                )}
                {invoiceTableData?.header?.map((data, index) => (
                  <TableCell key={index}>{data?.label}</TableCell>
                ))}
                <TableCell></TableCell> {/* Empty cell for the expand icon */}
              </TableRow>
            </TableHead>

            {invoiceTableData?.body?.length > 0 ? (
            <TableBody className="tableBodyStyle">
              {invoiceTableData?.body?.map((body, index) => (
                <React.Fragment key={index}>
                  <TableRow
                    onClick={() => handleRowClick(index, false,body)}
                    className={`colorBlack comRowChildWidth ${
                      expandedRow === index ? 'expandedRow' : ''
                    }`}
                  >
                    {props?.pageName !== 'paymentDetails' && (
                      <TableCell>
                        <Radio
                          checked={selectedRow === index}
                          onChange={() => handleRowClick(index, false, body)}
                        />
                      </TableCell>
                    )}
                    {invoiceTableData?.header?.map((header, idx) => (
                      <TableCell key={idx}>
                        {handleHeaderKey(header.key) 
                          ? `₹ ${abbreviateNumber(body[header.key]) || '0'}`
                          : body[header.key] || 'NA'}
                      </TableCell>
                    ))}
                    <TableCell>
                      <div className="justifyCenter">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent row click propagation
                            handleRowClick(index, true,body);
                          }}
                        >
                          {expandedRow === index ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                  {expandedRow === index && (
                    <TableRow>
                      <TableCell colSpan={invoiceTableData?.header?.length + 2}>
                        <iframe
                          title="PDF Viewer"
                          src={
                            body?.invoice?.url
                              ? body?.invoice?.url
                              : 'https://docs.google.com/viewer?url=' +
                                body?.settlementImg?.url +
                                '&embedded=true'
                          }
                          className="width100 height100vh"
                        ></iframe>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>) : (
              <TableRow>
              <StyledTableCell colSpan={12} align="center">
                <CommonNoDataFound />
              </StyledTableCell>
            </TableRow>
            )}
          </Table>
          {invoiceTableData?.body?.length > 0 && invoiceTableData?.totalCount > 10 &&
            props?.pageName !== 'paymentDetails' && (
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={invoiceTableData?.totalCount || 0}
                rowsPerPage={props?.rowsPerPage}
                page={props?.page}
                onPageChange={props?.handleChangePage}
                onRowsPerPageChange={props?.handleChangeRowsPerPage}
              />
            )}
        </TableContainer>
      )}
    </Box>
  );
};

export default PaymentTable;
